import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataTableTemplate from "../Components/DataTableTemplate";
import * as yup from "yup";
import { PanelContainer } from "../Components/PanelContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import {
  fetchData,
  formatNumber,
  getFilterButton,
  getFilterClearButton,
  getFilterDate,
  getFilterSelect,
} from "../Components/Utilities";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import ConvertRlsToCoinModal from "../Components/ConvertRlsToCoinModal";
import OutComeCoinModal from "../Components/OutComeCoinModal";
import InComeRlsModal from "../Components/InComeRlsModal";
import OutComeRlsModal from "../Components/OutComeRlsModal";
export const Fund = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isRlsToCoinModalOpen, setIsRlsToCoinModalOpen] = useState(false);
  const [isInComeRlsModal, setIsInComeRlsModdal] = useState(false);
  const [isOutComeRlsModal, setIsOutComeRlsModdal] = useState(false);
  const [remain, setRemain] = useState("");
  const [typeList, setTypeList] = useState([]);
  const rialRef = React.useRef(null);
  const navigate = useNavigate();
  const defaultValues = {};
  const {
    handleSubmit,
    control,
    reset,
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });
  const handleTypeApiResponse = (data) => {
    const mapCats = (apiResponse) => {
      return apiResponse?.map((item) => ({
        value: item.id.toString(),
        label: item.groupname,
      }));
    };
    const formattedOptions = mapCats(data?.dt);
    setTypeList(formattedOptions);
  };

  const closeRlsToCoinModal = () => {
    setIsRlsToCoinModalOpen(false);
    fetchIntialData()
  };
  const closeIncomeRlsModal = () => {
    setIsInComeRlsModdal(false);
    fetchIntialData()
  };
  const closeOutcomeRlsModal = () => {
    setIsOutComeRlsModdal(false)
    fetchIntialData()

  };

  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultDatatableRows,
    filters: {
      Date: { value: null, matchMode: FilterMatchMode.IN },
      type: { value: null, matchMode: FilterMatchMode.IN },
    },
  });

  const cols = [
    {
      field: "Date",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "Date",
      header: "تاریخ",
      sortable: true,
      filter: true,
      filterPlaceholder: "نام را وارد کنید",
      showFilterMatchModes: false,
      showFilterOperator: false,
      filterApply: getFilterButton,
      filterElement: (options) => getFilterDate(options, "", watch, control),
      filterClear: getFilterClearButton,
    },
    { field: "Time", header: "زمان" },
    {
      field: "income",
      header: "مبلغ دریافتی",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {(data?.income)}
        </p>
      ),
    },
    {
      field: "outcome",
      header: "مبلغ خرج شده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {(data?.outcome)}
        </p>
      ),
    },
    {
      field: "type",
      header: "نوع",
      body: (data) => data.typename,
      filter: true,
      filterPlaceholder: "گروه را انتخاب کنید",
      showFilterMatchModes: false,
      filterApply: getFilterButton,
      filterElement: (options) =>
        getFilterSelect(
          options,
          typeList,
          "type",
          "نوع عملیات را انتخاب کنید"
        ),
      filterClear: getFilterClearButton,
    },
    { field: "BillDesc", header: "توضیحات" },
  ];

  const openReceipt = () => {
    // setReceiptModalOpen(true); //
  };
  const onFilter = (event) => {
    event["first"] = 0;
    setLazyState((cur) => ({ ...cur, ...event }));
    console.log(event, "on filter");
  };
  const schema = yup.object({
    CatId: yup.string().required("دسته بندی انتخاب نشده است."),
    ManagerId: yup.string().required("مدیر انتخاب نشده است."),
  });
  useEffect(() => {
    fetchIntialData()
    const bodyFormData = new FormData();
    fetchData("fundtype", {}, handleTypeResponse);
  }, []);

  const fetchIntialData =() => {
    const bodyFormData = new FormData();
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("fund", bodyFormData, handleApiResponse);
  }
  const handleTypeResponse = (data) => {
    console.log(data?.dt);
    const mapOptions = (value) => {
      return value?.map((item) => ({
        value: item.id,
        label: `${item.typename}`,
      }));
    };
    const values = mapOptions(data?.dt);
    setTypeList(values);
  };
  const showRemainValue = formatNumber(remain)
  const onPage = (event) => {
    setLazyState((cur) => ({ ...cur, ...event }));
    setDefaultDatatableRows(event.rows);
  };
  let networkTimeout = null;
  useEffect(() => {
    loadLazyData(lazyState);
  }, [lazyState]);
  console.log(formatNumber(remain));
  const loadLazyData = (data) => {
    setLoading(true);
    if (networkTimeout) {
      clearTimeout(networkTimeout);
    }

    //imitate delay of a backend call
    networkTimeout = setTimeout(() => {
      const bodyFormData = new FormData();
      // bodyFormData.append("guid", Cookies.get("guid"));
      bodyFormData.append("pageNo", data?.page + 1 ?? 1);
      bodyFormData.append("pageSize", data?.rows ?? 20);
      if (data?.filters?.name?.value) {
        bodyFormData.append("name", data?.filters?.name?.value);
      }
      if (data?.filters?.groupid?.value) {
        bodyFormData.append("groupid", data?.filters?.groupid?.value);
      }
      if (data?.filters?.sex?.value) {
        bodyFormData.append("sex", data?.filters?.sex?.value);
      }
      if (data?.filters?.Mob?.value) {
        bodyFormData.append("mob", data?.filters?.Mob?.value);
      }
      if (data?.filters?.org?.value) {
        bodyFormData.append("org", data?.filters?.org?.value);
      }
      const handleApiResponse = (data) => {
        setTotalRecords(data?.count);
        setUserList(data?.dt);
        setLoading(false);
      };
      fetchIntialData()
    }, Math.random() * 1000 + 250);
  };

  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
    setRemain(data?.ballance);
  };

  const handleConvertRlsToCoin = (data) => {
    setIsRlsToCoinModalOpen(true);
  };
  const exportExcel = () => {
    console.log("first");
    import("xlsx").then((xlsx) => {
      const excelList = userList.map((item) => ({
        تاریخ: item.ckDate,
        "سکه دریافتی": item.ckIn,
        "سکه خرج شده": item.ckOut,
        " باقیمانده": item.remain,
        "نوع عملیات": item.typename,
        توضیحات: item.ckDesc,
      }));
      const worksheet = xlsx.utils.json_to_sheet(excelList);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      saveAsExcelFile(excelBuffer, "products");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const headerRial = (
    <div className="d-flex align-items-center justify-content-between dt-header">
      <div className="d-flex align-items-center justify-content-between gap-1">
        <FontAwesomeIcon
          onClick={exportExcel}
          className=" p-2 rounded bg-info text-white  cursor-pointer"
          icon={"file-excel"}
        />
        <div className="">
          <Button
            className=" btn btn-primary "
            onClick={handleConvertRlsToCoin}
          >
            <span> تبدیل ریال به پارسی </span>
            <span
              dir="rtl"
              style={{ direction: "ltr", textAlign: "center" }}
            ></span>
          </Button>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
        <Button className=" btn btn-secondary ">
          <span>موجودی: </span>
          <span dir="rtl" style={{ direction: "ltr", textAlign: "center" }}>
            {showRemainValue?.toLocaleString("en-US", {
                style: "decimal",
                maximumFractionDigits: 0,
              })}
          </span>
        </Button>

        <Button
          type={"button"}
          className="btn-success"
          onClick={() => setIsInComeRlsModdal(true)}
        >
          دریافت مبلغ
        </Button>
        <Button
          type={"button"}
          className="btn-info"
          onClick={() => setIsOutComeRlsModdal(true)}
        >
          پرداخت مبلغ
        </Button>
      </div>
    </div>
  );
  return (
    <>
      {/* Rls */}
      <ConvertRlsToCoinModal
        isOpen={isRlsToCoinModalOpen}
        closeModal={closeRlsToCoinModal}
        userId={userId}
        body={true}
      />
      <InComeRlsModal
        isOpen={isInComeRlsModal}
        closeModal={closeIncomeRlsModal}
        userId={userId}
        body={true}
      />
      <OutComeRlsModal
        isOpen={isOutComeRlsModal}
        closeModal={closeOutcomeRlsModal}
        userId={userId}
        body={true}
      />
      <div ref={rialRef}>
        <PanelContainer title={"صندوق ریالی"}>
          <div className="row text-right  p-sm-0  data-table">
            <div className="card-panel">
              <DataTableTemplate
                lazyState={lazyState}
                lazy
                // select='select'
                className={"table-border"}
                columns={cols}
                list={userList}
                totalRecords={totalRecords}
                setlazyState={setLazyState}
                setDefaultDatatableRows={setDefaultDatatableRows}
                defaultDatatableRows={defaultDatatableRows}
                width="25rem"
                header={headerRial}
                loading={loading}
                onFilter={onFilter}
                filters={lazyState.filters}
                onPage={onPage}
              />
            </div>
          </div>
        </PanelContainer>
      </div>
    </>
  );
};
